import { BACKEND_URL } from "../../Config";

export function isHeicFile(file: File): boolean {
    const name = file.name.toLowerCase();
    return name.endsWith('.heic') || name.endsWith('.heif') || file.type === 'image/heic' || file.type === 'image/heif';
}

export async function convertHeicToPng(file: File): Promise<Blob> {
    const formData = new FormData();
    formData.append("image", file);

    const response = await fetch(BACKEND_URL + "/convert_heic", {
        method: "POST",
        body: formData,
    });

    if (!response.ok) {
        throw new Error(`Failed to convert HEIC: ${response.status}`);
    }

    return await response.blob();
}
